import * as types from "./types";
import database from "../config/database";

export function action_FETCH_ProvidersImage(payload) {
  return {
    type: types.FETCH_PROVIDERS_IMAGE,
    value: payload
  };
}

export function f_FETCH_ProvidersImage(providerID) {
  return dispatch => {
    database.ref(`/app/providers/${providerID}`).once("value", snapshot => {
      const url = snapshot.val().fileURL;
      dispatch(
        action_FETCH_ProvidersImage({
          url
        })
      );
    });
  };
}

export function action_FETCH_Providers(payload) {
  return {
    type: types.FETCH_PROVIDERS,
    value: payload
  };
}

export function f_FETCH_Providers() {
  return dispatch => {
    database.ref("/app/providers").once("value", snapshot => {
      const providers = snapshot.val();
      dispatch(
        action_FETCH_Providers({
          ...providers
        })
      );
    });
  };
}

export function action_FILTERED_Providers(payload) {
  return {
    type: types.FETCH_FILTERED_PROVIDERS,
    value: payload
  };
}
export function f_FILTERED_Providers(d_start, d_end) {
  return dispatch => {
    const availableProviders_arr = [];

    database
      .ref("/app/timeslots")
      .orderByChild("durationTimestamp/start")
      .startAt(d_start)
      .endAt(d_end)
      .once("value", snapshot => {
        const filteredTimestamps = snapshot.val();

        if (filteredTimestamps) {
          Object.keys(filteredTimestamps).forEach(prov => {
            if (
              availableProviders_arr.indexOf(
                filteredTimestamps[prov].provider
              ) === -1
            )
              availableProviders_arr.push(filteredTimestamps[prov].provider);
          });

          dispatch(
            action_FILTERED_Providers({
              availableProviders: availableProviders_arr
            })
          );
        }
      });
  };
}
